var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout-view-container"},[_c('h1',{staticClass:"page-title-container"},[_vm._v("Abmeldung")]),_c('div',{staticClass:"view-container"},[_c('Popup',{on:{"close":function($event){return _vm.$router.push('/')}}},[_c('p',[_vm._v("Du wurdest erfolgreich abgemeldet!")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }